<!-- Page Header -->
<app-page-header></app-page-header>

<!-- Main content area -->
@if (!loading) {
  <div class="container py-2">
    <div class="row">
      <!-- Search Section (Left) -->
      <div class="col-md-7">
        <div class="card border-0 shadow-sm mb-3 search-card">
          <div class="card-header text-white"
            style="background-image: url('/assets/images/banner-main.png'); background-size: cover; background-position: center;">
            <h5 class="mb-0 text-white">
              <i class="fas fa-search me-2"></i>
              {{ 'SEARCH_TITLE' | translate }}
            </h5>
          </div>
          <div class="card-body">
            <div class="search-form">
              <!-- Search Scope Selection -->
              <div class="mb-3">
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="searchScope" id="scopeAll" [value]="0"
                    [(ngModel)]="searchScope">
                    <label class="form-check-label" for="scopeAll">{{ 'SEARCH_SCOPE_ALL' | translate }}</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="searchScope" id="scopeJournals" [value]="3"
                      [(ngModel)]="searchScope">
                      <label class="form-check-label" for="scopeJournals">{{ 'SEARCH_SCOPE_JOURNALS' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="searchScope" id="scopeArticles" [value]="1"
                        [(ngModel)]="searchScope">
                        <label class="form-check-label" for="scopeArticles">{{ 'SEARCH_SCOPE_ARTICLES' | translate }}</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="searchScope" id="scopeBooks" [value]="2"
                          [(ngModel)]="searchScope">
                          <label class="form-check-label" for="scopeBooks">{{ 'SEARCH_SCOPE_BOOKS' | translate }}</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" type="radio" name="searchScope" id="scopeAuthors" [value]="4"
                            [(ngModel)]="searchScope">
                            <label class="form-check-label" for="scopeAuthors">{{ 'SEARCH_SCOPE_AUTHORS' | translate }}</label>
                          </div>
                        </div>
                        <div class="input-group input-group-lg">
                          <input type="text" class="form-control" [(ngModel)]="quickSearchQuery"
                            [placeholder]="'SEARCH_PLACEHOLDER' | translate" (keyup.enter)="performQuickSearch()">
                            <button class="btn btn-primary" type="button" (click)="performQuickSearch()">
                              <i class="fas fa-search"></i>
                            </button>
                          </div>
                          <div class="mt-3 text-end">
                            <a href="javascript:void(0)" (click)="toggleAdvancedSearch()" class="text-primary">
                              <i class="fas fa-sliders-h me-1"></i>
                              {{ 'ADVANCED_SEARCH_TOGGLE' | translate }}
                              <i class="fas ms-1" [ngClass]="showAdvancedSearch ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Advanced Search Collapsible Section -->
                    <div class="advanced-search-collapse" [class.show]="showAdvancedSearch">
                      <div class="card border-0 shadow-sm mt-3">
                        <div class="card-body">
                          <app-advanced-search [isEmbedded]="true"></app-advanced-search>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Image Slider (Right) -->
                  <div class="col-md-5">
                    @if (sliderImages && sliderImages.length > 0) {
                      <app-image-slider [slides]="sliderImages" [autoPlay]="true"
                        [interval]="3000" [customHeight]="'250px'" [showIndicators]="true">
                      </app-image-slider>
                    }
                  </div>
                </div>
              </div>
            }

            <!-- Statistics Section -->
            <section class="page-header page-header-classic no-margin py-1"
              style="background-image: url('/assets/images/banner-main.png'); background-size: cover; background-position: center; background-repeat: no-repeat; height: 60%; min-height: 120px;">
              <div class="container">
                <div class="row counters counters-sm py-1">
                  <div class="col-sm-6 col-lg-3 mb-1 mb-lg-0">
                    <app-counter [targetValue]="summary.journals" [duration]="2000" [label]="'COUNTER_JOURNALS' | translate">
                    </app-counter>
                  </div>
                  <div class="col-sm-6 col-lg-3 mb-1 mb-lg-0">
                    <app-counter [targetValue]="summary.books" [duration]="2000" [label]="'COUNTER_BOOKS' | translate">
                    </app-counter>
                  </div>
                  <div class="col-sm-6 col-lg-3 mb-1 mb-sm-0">
                    <app-counter [targetValue]="summary.articles" [duration]="2000" [label]="'COUNTER_ARTICLES' | translate">
                    </app-counter>
                  </div>
                  <div class="col-sm-6 col-lg-3">
                    <app-counter [targetValue]="summary.authors" [duration]="2000" [label]="'COUNTER_AUTHORS' | translate">
                    </app-counter>
                  </div>
                </div>
              </div>
            </section>

            <!-- Journals Section -->
            <div class="container py-4">
              <app-box-view [title]="'MENU_JOURNALS' | translate" [tabs]="getJournalTabs()"
                [activeTabIndex]="selectedJournalTabIndex" (tabSelected)="selectJournalTab($event)">
                <div class="row">
                  @for (journal of journals[selectedJournalTabIndex]?.list; track journal) {
                    <div class="col-sm-6 col-md-4 col-lg-2 mb-4">
                      <div class="card h-100 shadow-sm journal-card">
                        <div class="journal-image-container">
                          <a href="journal/{{ journal.slug }}/home" target="_blank">
                            <img appCachedImage [src]="journal.coverShowcaseImageUrl" class="card-img-top" alt="{{ journal.name }}"
                              style="height: 200px; object-fit: contain;">
                            </a>
                          </div>
                          <br />
                          <hr class="card-divider">
                          <div class="card-body d-flex flex-column">
                            <h6 class="card-title journal-title"
                              style="font-size: 0.85rem; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; line-height: 1.3; word-wrap: break-word; overflow-wrap: break-word; height: 3.9em; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical;">
                            {{ journal.name }}</h6>
                            <hr class="card-divider">
                            @if (journal.eISSN && journal.eISSN != '0000-0000') {
                              <p class="card-text mt-auto">
                                <small class="text-muted text-xs"><strong>EISSN</strong> {{ journal.eISSN }}</small>
                              </p>
                            }
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </app-box-view>
              </div>

              <!-- Books Section -->
              <div class="container py-4">
                <app-box-view [title]="'MENU_BOOKS' | translate" [tabs]="getBookTabs()" [activeTabIndex]="selectedBookTabIndex"
                  (tabSelected)="selectBookTab($event)">
                  <div class="row">
                    @for (book of books[selectedBookTabIndex]?.list; track book) {
                      <div class="col-sm-6 col-md-4 col-lg-2 mb-4">
                        <div class="card h-100 shadow-sm book-card">
                          <div class="book-image-container">
                            <a href="book/{{ book.slug }}/home" target="_blank">
                              <img appCachedImage [src]="book.coverShowcaseImageUrl || book.coverImageUrl" class="card-img-top"
                                alt="{{ book.title }}" style="height: 200px; object-fit: contain;">
                              </a>
                            </div>
                            <br />
                            <hr class="card-divider">
                            <div class="card-body d-flex flex-column">
                              <h6 class="card-title book-title"
                                style="font-size: 0.85rem; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; line-height: 1.3; word-wrap: break-word; overflow-wrap: break-word; height: 3.9em; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical;">
                              {{ book.title }}</h6>
                              <hr class="card-divider">
                              @if (book.eISBN) {
                                <p class="card-text mt-auto">
                                  <small class="text-muted text-xs"><strong>EISBN</strong> {{ book.eISBN }}</small>
                                </p>
                              }
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </app-box-view>
                </div>


                <!-- Loading indicator -->
                @if (loading) {
                  <div class="text-center py-5">
                    <div class="spinner-border" role="status">
                      <span class="sr-only">{{ 'LOADING' | translate }}</span>
                    </div>
                  </div>
                }